<template>
	<div :class="`app-sidebar-container ${shouldShowFullSidebar ? 'opened' : ''}`">
		<div class="app-sidebar" @mouseenter="onMouseEnter" @mouseleave="onMouseLeave">
			<app-navigation
				:is-sidebar-open="shouldShowFullSidebar"
				@onSidebarItemOpened="$emit('onSidebarItemOpened')"
			/>
			<whats-app-button :phone="phoneNo" iconColor="floating-whatsapp" />
			<!--			<div class="app-navigation flex">-->
			<!--				<sidebar-item :to="{ name: RouteNames.Settings }" icon="settings" name="Settings" />-->
			<!--			</div>-->
			<div class="flex text-center justify-center gap-1" :class="shouldShowFullSidebar ? 'flex-row' : 'flex-col'">
				<span class="text-secondary text-13">
					{{ shouldShowFullSidebar ? 'BaboonPOS' : 'POS' }} v{{ appVersion }}
				</span>
				<span
					v-if="isNewVersion"
					class="bg-success text-white px-1 rounded-full text-8 font-semibold self-center w-6"
					:style="shouldShowFullSidebar ? { marginTop: '-8px' } : {}"
				>
					New
				</span>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import AppNavigation from '../Navigation';
	import RouteNames from '@/router/names';
	import UtilityService from '@/services/UtilityService';
	import WhatsAppButton from '@/components/app/WhatsAppButton.vue';
	import packageInfo from '../../../../package.json';
	import moment from 'moment';

	export default {
		name: 'Sidebar',
		components: {
			WhatsAppButton,
			AppNavigation,
		},
		data: () => ({
			RouteNames,
			appVersion: packageInfo.version,
			shouldShowOnHover: false,
		}),
		emits: ['onSidebarItemOpened'],
		computed: {
			...mapGetters({
				customClass: 'sidebar',
				user: 'user',
			}),
			isOpen() {
				return this.customClass === 'opened';
			},
			shouldShowFullSidebar() {
				return this.isOpen || this.shouldShowOnHover;
			},
			phoneNo() {
				return this.user?.city?.id === 2 ? '+38348400723' : '+355677070202';
			},
			isNewVersion() {
				return this.checkIfNewVersion();
			},
		},
		methods: {
			onMouseEnter() {
				if (!UtilityService.isMobile()) {
					this.shouldShowOnHover = true;
				}
			},
			onMouseLeave() {
				this.shouldShowOnHover = false;
			},
			goHome() {
				this.$router.push({ name: RouteNames.OrdersKanban });
			},
			logout() {
				this.$store.dispatch('logout');
				this.$router.push({ name: RouteNames.Login });
			},
			settings() {
				this.$notificationService.info('Not implemented yet');
			},
			checkIfNewVersion() {
				const releaseDate = moment(packageInfo.releaseDate, 'YYYY-MM-DD');
				const currentDate = moment();
				const diffInDays = currentDate.diff(releaseDate, 'days');
				return diffInDays <= 2;
			},
		},
	};
</script>
